/* eslint-disable */
/* eslint-disable indent, react/jsx-indent, no-trailing-spaces */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { QueryVal } from 'Helpers/Query';
import Dialog from 'Components/UI/Dialog';
import { closeModalWithAdditionalKeys, openModal } from 'Helpers/ModalHelper';
import moment from 'moment';
import Receipt from 'Components/UI/Receipts/receipt';
import { DialogContent, DialogTitle, Divider } from '@material-ui/core';
import { combineNames } from 'Helpers/Client';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { wasFailedPayment } from 'Helpers/invoice';
import modalTypes from 'Consts/ModalNames';
import Button from 'Components/UI/Button';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

const baseStyle = makeStyles(theme => ({
  primaryBlue: {
    color: theme.palette.primary.main,
  },
  paymentError: {
    color: theme.palette.error.main,
  },
  modalHeader: {
    margin: `${theme.spacing(1)}px 0`,
    fontSize: '1.25rem',
    fontWeight: 500,
  },
  modalHeaderRow: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const InvoiceReceiptModal = (isAgentView = false) => {
  const classes = baseStyle();

  const { householdResource: hhR, invoiceReceipts, getInvoiceReceipts } = useSimpleHousehold();

  const invoiceId = QueryVal('invoiceId');

  useEffect(getInvoiceReceipts, [hhR]);

  const invoice = invoiceReceipts.find(inv => inv.attr('invoiceID') === invoiceId);

  if(!invoice) return null;

  const clientNames = combineNames(
    hhR.attr('primaryClientFirstName'),
    hhR.attr('primaryClientLastName'),
    hhR.attr('spouseClientFirstName'),
    hhR.attr('spouseClientLastName'),
  );

  const date = moment.utc(invoice.attr('createdAt')).format('MMMM D, YYYY');

  const headerColor = wasFailedPayment(invoice)
    ? classes.paymentError
    : classes.primaryBlue;

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      onClose={() => closeModalWithAdditionalKeys(['invoiceId'])}
      showCloseIcon
      scroll="paper"
    >
      <DialogTitle>
        <div className={classnames(classes.modalHeaderRow)}>
          <Button
            color="secondary"
            disabled={false}
            onClick={() => openModal(modalTypes.invoiceReceiptsModal)}
            variant={'icon'}
            padding={'dense'}
            className={classnames(headerColor)}
          >
            <ChevronLeftIcon />
          </Button>
          <span className={classnames(headerColor, classes.modalHeader)}>
            {`Receipt - ${clientNames} - ${date}`}
          </span>
        </div>
        <Divider />
      </DialogTitle>
      <DialogContent>
        <Receipt invoice={invoice} household={hhR} isAgentView={isAgentView} />
      </DialogContent>
    </Dialog>
  );
};

export const ClientInvoiceReceiptModal = () => InvoiceReceiptModal(false);

ClientInvoiceReceiptModal.propTypes = {};

ClientInvoiceReceiptModal.defaultProps = {};

export const AgentInvoiceReceiptModal = () => InvoiceReceiptModal(true);
